import {
    itemEditor,
    ui
} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {ItemNameLogic} from "./item-name-logic";
import {OrderInfo}     from "./ui/order-info";

export const itemNameModules = ({item, getDefaultValue}) => [
    {
        name: "itemName",
        load: ({lineItems, method, totalQuantity}, next) => ItemNameLogic({
            item,
            getDefaultValue,
            next,
        }),
        expo: [itemEditor],
        requires: [],
    },

    {
        load: ({itemName, variationsStock}, next) => next({
            ui: ({className, templateOptions, oia,}) => OrderInfo({
                ...itemName.ui,
                className, templateOptions, oia,
                variationsStock,
            })
        }),
        expo: [ui("orderInfo")],
        requires: ["itemName"],
        requiresOptional: ["variationsStock"],
    },

];
